/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import React, { useState, useEffect } from 'react';
import { g as get_1 } from '../../_chunks/dep-337b4140.js';
import { getValueToOption } from '../util/helper.js';
import Option from '../base/Option.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-ca64038e.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-33ffecad.js';
import '../../_chunks/dep-fd3498b6.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-6506fbc2.js';
import '../base/OptionGroup.js';
import 'classnames';
import '../../hooks/useConfig.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../defaultProps.js';
import '../../_chunks/dep-0e15088f.js';
import '../../_chunks/dep-6c5254c6.js';
import '../../hooks/useDomRefCallback.js';
import '../../_util/useRipple.js';
import '../../_util/useAnimation.js';
import '../../_util/setStyle.js';
import '../../_util/dom.js';
import 'raf';
import '../../_util/easing.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function UseOptions(keys, options, children, valueType, value) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    currentOptions = _useState2[0],
    setCurrentOptions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    tmpPropOptions = _useState4[0],
    setTmpPropOptions = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    valueToOption = _useState6[0],
    setValueToOption = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedOptions = _useState8[0],
    setSelectedOptions = _useState8[1];
  useEffect(function () {
    var transformedOptions = options;
    var arrayChildren = React.Children.toArray(children);
    var isChildrenFilterable = arrayChildren.length > 0 && arrayChildren.filter(function (v) {
      return v.type === Option;
    }).length === arrayChildren.length;
    if (isChildrenFilterable) {
      transformedOptions = arrayChildren.map(function (v) {
        if ( /*#__PURE__*/React.isValidElement(v)) {
          return _objectSpread(_objectSpread({}, v.props), {}, {
            label: v.props.label || v.props.children
          });
        }
        return {
          label: v
        };
      });
    }
    if (keys) {
      var _transformedOptions;
      transformedOptions = (_transformedOptions = transformedOptions) === null || _transformedOptions === void 0 ? void 0 : _transformedOptions.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          value: get_1(option, (keys === null || keys === void 0 ? void 0 : keys.value) || "value"),
          label: get_1(option, (keys === null || keys === void 0 ? void 0 : keys.label) || "label")
        });
      });
    }
    setCurrentOptions(transformedOptions);
    setTmpPropOptions(transformedOptions);
    setValueToOption(getValueToOption(children, options, keys) || {});
  }, [options, keys, children]);
  useEffect(function () {
    setSelectedOptions(function (oldSelectedOptions) {
      var valueKey = (keys === null || keys === void 0 ? void 0 : keys.value) || "value";
      var labelKey = (keys === null || keys === void 0 ? void 0 : keys.label) || "label";
      if (Array.isArray(value)) {
        return value.map(function (item) {
          if (valueType === "value") {
            var _ref;
            return valueToOption[item] || oldSelectedOptions.find(function (option) {
              return get_1(option, valueKey) === item;
            }) || (_ref = {}, _defineProperty(_ref, valueKey, item), _defineProperty(_ref, labelKey, item), _ref);
          }
          return item;
        }).filter(Boolean);
      }
      if (value !== void 0 && value !== null) {
        if (valueType === "value") {
          var _ref2;
          return [valueToOption[value] || oldSelectedOptions.find(function (option) {
            return get_1(option, valueKey) === value;
          }) || (_ref2 = {}, _defineProperty(_ref2, valueKey, value), _defineProperty(_ref2, labelKey, value), _ref2)].filter(Boolean);
        }
        return [value];
      }
      return [];
    });
  }, [value, keys, valueType, valueToOption, setSelectedOptions]);
  return {
    currentOptions: currentOptions,
    setCurrentOptions: setCurrentOptions,
    tmpPropOptions: tmpPropOptions,
    setTmpPropOptions: setTmpPropOptions,
    valueToOption: valueToOption,
    setValueToOption: setValueToOption,
    selectedOptions: selectedOptions,
    setSelectedOptions: setSelectedOptions
  };
}

export { UseOptions as default };
//# sourceMappingURL=useOptions.js.map
